import { useForm } from 'react-hook-form';
import { styled } from '@mui/material';
import { forwardRef, useEffect, useImperativeHandle } from 'react';
import { AdminSettingFormRef } from './AdminSettingsDialog';
import { useCommonTranslation } from '../../../hooks/useCommonTranslation';
import { AdminSettingId } from './AdminSettings';
import Checkbox from '../../forms/Checkbox';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  marginTop: theme.spacing(-1),
  marginLeft: 2,
}));

interface SingleCheckboxFieldFormProps {
  settingId: AdminSettingId;
  value?: boolean;
}

export const SingleCheckboxFieldForm = forwardRef<
  AdminSettingFormRef,
  SingleCheckboxFieldFormProps
>(({ value, settingId }, ref) => {
  const t = useCommonTranslation();
  const {
    control,
    setValue,
    getValues,
    trigger,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: { [settingId]: false },
  });

  useImperativeHandle(ref, () => ({
    getValues,
    triggerValidation: () => trigger(),
    isValid,
  }));

  useEffect(() => {
    if (value != null) {
      setValue(settingId, value);
    }
  }, [value]);

  return (
    <StyledCheckbox
      label={t('adminSettings.enabled')}
      name={settingId}
      control={control}
    />
  );
});
